import { get } from 'lodash'
export default function () {
  if (get(this.$route, 'params.rtn', null) === null) {
    this.getYears()
  }

  if (this.user.image_required === 'true') {
    if (this.user.image_id === null) {
      this.$toast.error('Você precisa definir uma foto no seu perfil.')
      return this.$router.push({name: 'dweller.profile.me.me'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/meeting/resources/mounted.js